import React from 'react'
import PropTypes from 'prop-types'
import MenuItem from './NavbarLink.styles'
import Chevron from './primitives/Chevron.js'
import { Link } from 'gatsby'

const NavbarLink = ({ text, show, slug }) => (
  <>
    {!slug ? (
      <MenuItem show={show}>
        {text}
        <Chevron show={show} />
      </MenuItem>
    ) : (
      <MenuItem>
        <Link activeClassName="active-link" to={slug}>
          {text}
        </Link>
      </MenuItem>
    )}
  </>
)

NavbarLink.propTypes = {
  text: PropTypes.string.isRequired,
  show: PropTypes.bool,
}

NavbarLink.defaultProps = {
  show: false,
}

export default NavbarLink
